import React from "react";

export default (props: React.SVGProps<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 5435.8 1604"
      {...props}
    >
      <path
        d="M5234.4 1604h-5033C90.4 1604 0 1513.6 0 1403.5v-1203C0 90 90.4 0 201.4 0h5033c110.9 0 201.4 90 201.4 200.5v1203c0 110.1-90.5 200.5-201.4 200.5z"
        style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      />
      <path
        d="M5234.4 32.1c93.1 0 169.3 75.7 169.3 168.4v1203c0 92.7-75.7 168.4-169.3 168.4h-5033c-93.1 0-169.3-75.7-169.3-168.4v-1203c0-92.7 75.7-168.4 169.3-168.4h5033zm0-32.1h-5033C90.4 0 0 90.4 0 200.5v1203C0 1514 90.4 1604 201.4 1604h5033c110.9 0 201.4-90 201.4-200.5v-1203C5435.8 90.4 5345.3 0 5234.4 0z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#a6a6a6" }}
      />
      <path
        d="M2863.6 530.6c-36.3 0-66.9-12.7-91.1-37.7-24-24.3-37.4-57.8-36.8-92 0-36.5 12.4-67.4 36.8-91.9 24.1-25 54.7-37.7 91-37.7 35.9 0 66.5 12.7 91.1 37.7 24.4 25.3 36.8 56.2 36.8 91.9-.4 36.6-12.8 67.5-36.8 91.9-24.1 25.2-54.7 37.8-91 37.8zm-1080.1 0c-35.5 0-66.3-12.5-91.5-37.2-25-24.6-37.7-55.7-37.7-92.4s12.7-67.8 37.7-92.4c24.7-24.7 55.5-37.2 91.5-37.2 17.6 0 34.7 3.5 51.1 10.6 16.1 6.9 29.2 16.3 38.9 27.8l2.4 2.9-27.1 26.6-2.8-3.3c-15.3-18.2-35.8-27.1-62.9-27.1-24.2 0-45.3 8.6-62.7 25.6-17.5 17.1-26.4 39.5-26.4 66.6s8.9 49.5 26.4 66.6c17.4 17 38.5 25.6 62.7 25.6 25.8 0 47.5-8.6 64.4-25.6 10-10 16.2-24 18.4-41.7H1779v-37.4h124.2l.5 3.4c.9 6.3 1.8 12.8 1.8 18.8 0 34.5-10.4 62.4-31 83-23.4 24.4-54 36.8-91 36.8zm1436.1-5.3h-38.3L3064 337.6l1 33.8v153.8h-38.3V276.7h43.7l1.2 1.9 110.3 176.8-1-33.7v-145h38.7v248.6zm-643.8 0H2537V314.1h-67.3v-37.4H2643v37.4h-67.3v211.2zm-137.7 0h-38.7V276.7h38.7v248.6zm-217.5 0h-38.7V314.1h-67.3v-37.4h173.3v37.4h-67.3v211.2zm-130.5-.4h-148.4V276.7h148.4v37.4h-109.6v68.2h98.9v37h-98.9v68.2h109.6v37.4zm710.8-57.7c17.3 17.3 38.3 26 62.7 26 25.1 0 45.6-8.5 62.7-26 17-17 25.6-39.3 25.6-66.2s-8.6-49.3-25.5-66.2c-17.3-17.3-38.4-26-62.7-26-25.1 0-45.6 8.5-62.6 26-17 17-25.6 39.3-25.6 66.2s8.5 49.3 25.4 66.2z"
        style={{ fill: "#fff" }}
      />
      <path
        d="M2732.1 872.4c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.6-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4.1 61-44.5 103.4-96.2 103.4zm-373.3-273.6c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.7-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4 0 61-44.5 103.4-96.2 103.4zm-444.2-221.5v72.2h173.3c-5.3 40.5-18.7 70.4-39.2 90.9-25.4 25.4-64.6 53-133.7 53-106.5 0-189.8-86-189.8-192.5s83.3-192.5 189.8-192.5c57.5 0 99.4 22.7 130.5 51.7l51.2-51.2c-43.2-41.4-100.7-73.1-181.3-73.1-146.1 0-268.7 119-268.7 264.7 0 146.1 122.5 264.7 268.7 264.7 78.9 0 138.1-25.8 184.9-74.4 47.7-47.7 62.8-115 62.8-169.3 0-16.9-1.3-32.1-4-45h-244.6c.1-.1.1.8.1.8zm1816.9 56.2C3717.2 942.4 3674 872 3585.4 872c-87.8 0-160.8 69.1-160.8 170.6 0 95.8 72.2 170.6 169.3 170.6 78 0 123.4-47.7 142.1-75.7l-57.9-38.8c-19.2 28.5-45.9 47.2-83.8 47.2-38.3 0-65.1-17.4-82.9-51.7l228.1-94.5c0 .1-8-19-8-19zm-232.6 57c-1.8-65.9 51.2-99.4 89.1-99.4 29.9 0 54.8 14.7 63.3 36.1l-152.4 63.3zM3313.6 1203h74.9V701.8h-74.9V1203zm-123-292.7h-2.7c-16.9-20.1-49-38.3-90-38.3-85.1 0-163.5 74.9-163.5 171.1 0 95.8 78 169.8 163.5 169.8 40.5 0 73.1-18.3 90-38.8h2.7v24.5c0 65.1-34.8 100.2-90.9 100.2-45.9 0-74.4-33-86-60.6l-65.1 27.2c18.7 45 68.6 100.7 151 100.7 87.8 0 162.2-51.7 162.2-177.8V882.2H3191v28.1h-.4zm-86 235.7c-51.7 0-94.9-43.2-94.9-102.9 0-60.2 43.2-103.8 94.9-103.8 51.2 0 90.9 44.1 90.9 103.8.5 59.7-39.6 102.9-90.9 102.9zm977.6-444.2h-179.1V1203h74.9v-189.8h104.3c82.9 0 164.4-60.1 164.4-155.5s-81.2-155.9-164.5-155.9zm2.2 241.4h-106.5v-172h106.5c56.1 0 87.8 46.3 87.8 86 0 39.3-32.1 86-87.8 86zm462.5-71.7c-54.4 0-110.5 24.1-133.7 76.6l66.4 27.6c14.3-27.6 40.5-37 68.2-37 38.8 0 78 23.2 78.9 64.6v5.3c-13.4-7.6-42.8-19.2-78-19.2-71.7 0-144.4 39.2-144.4 112.7 0 67.3 58.8 110.5 124.3 110.5 50.3 0 78-22.7 95.3-49h2.7v38.8h72.2v-192c0-89.4-66.4-138.9-151.9-138.9zm-9.4 274.5c-24.5 0-58.8-12-58.8-42.8 0-38.8 42.8-53.5 79.3-53.5 33 0 48.6 7.1 68.2 16.9-5.4 45-43.4 79-88.7 79.4zm424.7-263.8-86 217.4h-2.7l-89.1-217.4h-80.6l133.7 303.9-76.2 168.9h78L5045 882.2h-82.8zM4288 1203h74.9V701.8H4288V1203z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "#fff" }}
      />
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1="1682.108"
        y1="1339.478"
        x2="1624.292"
        y2="1309.634"
        gradientTransform="matrix(11.64 0 0 -22.55 -18705.596 30554.37)"
      >
        <stop offset="0" style={{ stopColor: "#00a0ff" }} />
        <stop offset=".007" style={{ stopColor: "#00a1ff" }} />
        <stop offset=".26" style={{ stopColor: "#00beff" }} />
        <stop offset=".512" style={{ stopColor: "#00d2ff" }} />
        <stop offset=".76" style={{ stopColor: "#00dfff" }} />
        <stop offset="1" style={{ stopColor: "#00e3ff" }} />
      </linearGradient>
      <path
        d="M418.4 302.1c-11.6 12.5-18.3 31.6-18.3 56.6v886.7c0 25 6.7 44.1 18.7 56.1l3.1 2.7 496.8-496.8v-11.1L421.5 299.4l-3.1 2.7z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "url(#a)" }}
      />
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1="1712.662"
        y1="1274.838"
        x2="1606.561"
        y2="1274.838"
        gradientTransform="matrix(9.145 0 0 -7.7 -14305.538 10618.251)"
      >
        <stop offset="0" style={{ stopColor: "#ffe000" }} />
        <stop offset=".409" style={{ stopColor: "#ffbd00" }} />
        <stop offset=".775" style={{ stopColor: "orange" }} />
        <stop offset="1" style={{ stopColor: "#ff9c00" }} />
      </linearGradient>
      <path
        d="M1084 973.5 918.3 807.8v-11.6L1084 630.5l3.6 2.2 196 111.4c56.1 31.6 56.1 83.8 0 115.8l-196 111.4-3.6 2.2z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "url(#b)" }}
      />
      <linearGradient
        id="c"
        gradientUnits="userSpaceOnUse"
        x1="1707.441"
        y1="1290.047"
        x2="1646.682"
        y2="1211.223"
        gradientTransform="matrix(15.02 0 0 -11.5775 -24650.229 15829.648)"
      >
        <stop offset="0" style={{ stopColor: "#ff3a44" }} />
        <stop offset="1" style={{ stopColor: "#c31162" }} />
      </linearGradient>
      <path
        d="M1087.6 971.3 918.3 802l-499.9 499.9c18.3 19.6 49 21.8 83.3 2.7l585.9-333.3"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "url(#c)" }}
      />
      <linearGradient
        id="d"
        gradientUnits="userSpaceOnUse"
        x1="1660.636"
        y1="1365.668"
        x2="1687.767"
        y2="1330.45"
        gradientTransform="matrix(15.02 0 0 -11.5715 -24650.229 15809.992)"
      >
        <stop offset="0" style={{ stopColor: "#32a071" }} />
        <stop offset=".069" style={{ stopColor: "#2da771" }} />
        <stop offset=".476" style={{ stopColor: "#15cf74" }} />
        <stop offset=".801" style={{ stopColor: "#06e775" }} />
        <stop offset="1" style={{ stopColor: "#00f076" }} />
      </linearGradient>
      <path
        d="M1087.6 632.7 501.7 299.9c-34.3-19.6-65.1-16.9-83.3 2.7L918.3 802l169.3-169.3z"
        style={{ fillRule: "evenodd", clipRule: "evenodd", fill: "url(#d)" }}
      />
      <path
        d="m1084 967.7-581.9 330.6c-32.5 18.7-61.5 17.4-80.2.4l-3.1 3.1 3.1 2.7c18.7 16.9 47.7 18.3 80.2-.4L1088 971.3l-4-3.6z"
        style={{
          opacity: 0.2,
          fillRule: "evenodd",
          clipRule: "evenodd",
        }}
      />
      <path
        d="m1283.6 854.1-200.1 113.6 3.6 3.6 196-111.4c28.1-16 41.9-37 41.9-57.9-1.7 19.2-16 37.4-41.4 52.1z"
        style={{
          opacity: 0.12,
          fillRule: "evenodd",
          clipRule: "evenodd",
        }}
      />
      <path
        d="m501.7 305.7 781.9 444.2c25.4 14.3 39.7 33 41.9 52.1 0-20.9-13.8-41.9-41.9-57.9L501.7 299.9c-56.1-32.1-101.6-5.3-101.6 58.8v5.8c0-64.2 45.5-90.5 101.6-58.8z"
        style={{
          opacity: 0.25,
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#fff",
        }}
      />
    </svg>
  );
};
